import { PreferenceRadioOption } from './preferences.model';

export const BOOLEAN_TOGGLE_OPTIONS: PreferenceRadioOption[] = [
  { label: 'FCT.REPORTING.HEADER.PREFERENCES.SETTING.ON', value: 'true' },
  { label: 'FCT.REPORTING.HEADER.PREFERENCES.SETTING.OFF', value: 'false' },
];
